import { useState } from 'react';

import { useNavigation } from '@web/navigation/NavigationProvider';
import { Article } from '@web/newsfeed/types/Article';
import { useArticleSearchContext } from '@web/newsfeed/ArticleSearch/ArticleSearchProvider/ArticleSearchProvider';

export const useArticleSearchItem = (article: Article) => {
  const { navigate } = useNavigation();
  const { searchPageId, searchQuery } = useArticleSearchContext();
  const [isPreview, setIsPreview] = useState(true);

  const openArticle = () => {
    navigate('newsfeed.view.search', {
      articleId: article.id,
      pageId: article.page.id,
      searchPageId: searchPageId,
      query: searchQuery,
    });
  };

  const onSeeMore = (event: React.MouseEvent<HTMLElement>) => {
    setIsPreview(false);
    event?.stopPropagation();
  };

  return {
    openArticle,
    isPreview,
    onSeeMore,
  };
};
